module.exports = __webpack_public_path__ + "static/mobile-dddaf0728897abb3b3a6c8581d03e776.jpg";